/* lua.js generated code 0.3.0 */

var GameGuidePosition = require("clover/gameGuide/GameGuidePosition")
var GameGuideMask = xClass("GameGuideMask")
var defaultMaskOpacity = 170
GameGuideMask.create = function (action, paras, width, height) {
    var self = this
    var opacity = action.opacity || defaultMaskOpacity
    var holes = action.hole || table()
    var touches = action.touch || table()
    var wSize = cc.Director.getInstance().getWinSize()
    var width = width || wSize.width
    var height = height || wSize.height
    var deltaX = (width - wSize.width) / 2
    var deltaY = (height - wSize.height) / 2
    paras && (paras.instance = paras.instance || paras.panel)
    
    var render = cc.RenderTexture.create(width, height)
    render.retain()
    render.setPosition(cc.p(width / 2, height / 2))
    var [updateMasks, renderMasks] = [table(), table()]
    for (var i = 1, v = holes[1]; v; i++ , v = holes[i]) {
        var funcName = string.upper(string.sub(tostring(v.type), 1, 1)) + string.sub(tostring(v.type), 2)
        if (type(self["maskHole" + funcName]) === "function") {
            var obj = self["maskHole" + funcName](v, paras)
            if (obj) {
                obj.setBlendFunc(table([1, "src", gl.ZERO], [1, "dst", gl.ONE_MINUS_SRC_ALPHA]))
                var { x, y } = obj.getPosition()
                obj.setPosition(x + deltaX, y + deltaY)
                if (obj.scaleTime > 0) {
                    table.insert(updateMasks, obj)
                }
                obj.retain()
                table.insert(renderMasks, obj)
            }
        }
    }
    render.beginWithClear(0, 0, 0, opacity)
    for (var i = 1, v = renderMasks[1]; v; i++ , v = renderMasks[i]) {
        v.visit()
    }
    render.endToLua()
    var sprite = render.getSprite()
    var texture = sprite.getTexture()
    texture.setAntiAliasTexParameters()
    sprite.setAnchorPoint(cc.p(0, 0))
    sprite.removeFromParent(true)
    var layer = cc.Layer.create()
    layer.enableNodeEvents()
    if ($len(updateMasks) > 0) {
        var dtRec = 0
        layer.onUpdate(function (deltaTime) {
            if (!updateMasks) {
                for (var i = 1, v = renderMasks[1]; v; i++ , v = renderMasks[i]) {
                    v.release()
                }
                renderMasks = table()
                layer.unscheduleUpdate()
                return
            }
            dtRec = dtRec + deltaTime
            var newTable = table()
            for (var i = 1, v = updateMasks[1]; v; i++ , v = updateMasks[i]) {
                if (dtRec >= v.scaleTime) {
                    v.setScale(1)
                } else {
                    v.setScale((v.startScale - 1) * (1 - dtRec / v.scaleTime) + 1)
                    table.insert(newTable, v)
                }
            }
            // updateMasks = newTable
            render.beginWithClear(0, 0, 0, opacity)
            for (var i = 1, v = renderMasks[1]; v; i++ , v = renderMasks[i]) {
                v.visit()
                circle = v
            }
            render.endToLua()
            if ($len(updateMasks) <= 0) {
                updateMasks = null
            }
        })
    }
    layer.cleanup = function (self) {
        cc.Layer.prototype.cleanup.call(this)
        for (var i = 1, v = renderMasks[1]; v; i++ , v = renderMasks[i]) {
            v.release()
        }
        renderMasks = table()
        layer.unscheduleUpdate()
        render.release()
    }
    layer.addChild(sprite)
    var enableTouch = false
    var listenner = cc.EventListenerTouchOneByOne.create()
    listenner.setSwallowTouches(false)
    listenner.registerScriptHandler(function (touch, event) {
        for (var i = 1, v = touches[1]; v; i++ , v = touches[i]) {
            var funcName = string.upper(string.sub(tostring(v.type), 1, 1)) + string.sub(tostring(v.type), 2)
            if (type(self["maskTouch" + funcName]) === "function" && self["maskTouch" + funcName](v, touch, event, paras)) {
                listenner.setSwallowTouches(!enableTouch)
                return true
            }
        }
        listenner.setSwallowTouches(true)
        return true
    }, cc.Handler.EVENT_TOUCH_BEGAN)
    listenner.registerScriptHandler(function (touch, event) {
        for (var i = 1, v = touches[1]; v; i++ , v = touches[i]) {
            var funcName = string.upper(string.sub(tostring(v.type), 1, 1)) + string.sub(tostring(v.type), 2)
            if (type(self["maskTouch" + funcName]) === "function" && self["maskTouch" + funcName](v, touch, event, paras)) {
                listenner.setSwallowTouches(!enableTouch)
                return true
            }
        }
        listenner.setSwallowTouches(true)
        return true
    }, cc.Handler.EVENT_TOUCH_MOVED)
    listenner.registerScriptHandler(function (touch, event) {
        action.skipCb && action.skipCb()
        if (enableTouch && action.touchSkip) {
            GameGuide.getInstance().onGuideComplete()
        }
        for (var i = 1, v = touches[1]; v; i++ , v = touches[i]) {
            var funcName = string.upper(string.sub(tostring(v.type), 1, 1)) + string.sub(tostring(v.type), 2)
            if (type(self["maskTouch" + funcName]) === "function" && self["maskTouch" + funcName](v, touch, event, paras)) {
                listenner.setSwallowTouches(!enableTouch)
                return true
            }
        }
        listenner.setSwallowTouches(true)
        return true
    }, cc.Handler.EVENT_TOUCH_ENDED)
    var eventDispatcher = layer.getEventDispatcher()
    eventDispatcher.addEventListenerWithSceneGraphPriority(listenner, layer)
    layer.setCascadeOpacityEnabled(true)
    if ((action.delay || 0) + (action.fade || 0) > 0) {
        layer.setOpacity(0)
        layer.runAction(cc.Sequence.create(cc.DelayTime.create(action.delay || 0), cc.CallFunc.create(function () {
            layer.runAction(cc.FadeTo.create(action.fade || 0, opacity))
            layer.runAction(cc.Sequence.create(cc.DelayTime.create(action.touchDelay || ((action.delay || 0) + (action.fade || 0))), cc.CallFunc.create(function () {
                enableTouch = true
            })))
        })))
    } else {
        layer.setOpacity(opacity)
    }
    return layer
}
GameGuideMask.maskHoleSquare = function (config, paras) {
    var [x, y, width, height] = GameGuidePosition.getPosition(config.posMode, (paras || table()).instance || (paras || table()).panel, config.p1, config.p2, config.width, config.height, config.posRatio, config.posAdd, config.sizeRatio)
    // FIXME: RenderTexture
    var blurValue = config.border || 0
    if (blurValue) {
        x -= blurValue
        y -= blurValue
        blurValue = 0
    }
    var ret
    if (blurValue !== 0) {
        var blur = display.newGroupFilteredSprite(table("GAUSSIAN_VBLUR", "GAUSSIAN_HBLUR"), table([0, table([0, blurValue || 0])], [0, table([0, blurValue || 0])]))
        var ph = cc.Layer.create()
        ph.setContentSize(cc.size(width + blurValue * 2, height + blurValue * 2))
        blur.addChild(ph)
        var square = cc.LayerColor.create()
        square.setContentSize(cc.size(width, height))
        square.setOpacity(255)
        square.setPosition(cc.p(blurValue, blurValue))
        blur.addChild(square)
        var render = cc.RenderTexture.create(width + blurValue * 2, height + blurValue * 2)
        render.begin()
        blur.visit()
        render.endToLua()
        ret = render.getSprite()
    } else {
        ret = cc.LayerColor.create()
        ret.ignoreAnchorPointForPosition(false)
        ret.setContentSize(cc.size(width, height))
        ret.setOpacity(255)
    }
    //
    let align = config.align;
    let dx = 0, dy = 0;
    if (align) {
        let tileSize = GameGuidePosition.getTileSize();
        switch (align) {
            case "top":
                dy = tileSize.height - height / 2
                break;
            case "belowTop":
                dy = tileSize.height - height
                break;
            case "aboveTop":
                dy = tileSize.height
                break;
            case "bottom":
                dy = 0 - height / 2
                break;
            case "belowBottom":
                dy = 0 - height
                break;
            case "aboveBottom":
                dy = 0
                break;
            case "left":
                dx = 0 - width / 2
                break;
            case "right":
                dx = tileSize.width - width / 2
                break;
        }
    }
    //
    ret.setAnchorPoint(cc.p(0.5, 0.5))
    ret.removeFromParent(true)
    ret.setPosition(cc.p(x + width / 2 + dx, y + height / 2 + dy))
    if (type(config.startScale) === "number" && config.startScale !== 0) {
        ret.startScale = config.startScale
        ret.setScale(ret.startScale)
    }else{
        var vSize = cc.Director.getInstance().getVisibleSize()
        var distance = Math.max(Math.max(x, y), Math.max(vSize.width - x - width, vSize.height - y - height))
        var targetWidth = distance * 2 + width
        ret.startScale = targetWidth / width
        ret.setScale(ret.startScale)
        ret.scaleTime = config.scaleTime || 0.3
    }
    return ret
}
GameGuideMask.maskHoleOval = function (config, paras) {
    var [x, y, width, height] = GameGuidePosition.getPosition(config.posMode, (paras || table()).instance || (paras || table()).panel, config.p1, config.p2, config.width, config.height, config.posRatio, config.posAdd, config.sizeRatio)
    // FIXME: RenderTexture
    var blurValue = config.border || 0
    if (blurValue) {
        // 定位方式不同，有偏差
        if (config.posMode !== 'propBar') {
            x -= blurValue
            y -= blurValue
        }
        blurValue = 0
    }
    var ret
    if (blurValue !== 0) {
        var blur = display.newGroupFilteredSprite(table("GAUSSIAN_VBLUR", "GAUSSIAN_HBLUR"), table([0, table([0, blurValue || 0])], [0, table([0, blurValue || 0])]))
        var ph = cc.Layer.create()
        ph.setContentSize(cc.size(width + blurValue * 2, height + blurValue * 2))
        blur.addChild(ph)
        var node = cc.DrawNode.create()
        var radius = Math.max(width, height) / 2
        node.drawDot(cc.p(0, 0), radius, cc.c4f(0, 0, 0, 1))
        node.setScaleX(width / radius / 2)
        node.setScaleY(height / radius / 2)
        node.setPosition(cc.p(width / 2 + blurValue, height / 2 + blurValue))
        blur.addChild(node)
        var render = cc.RenderTexture.create(width + blurValue * 2, height + blurValue * 2)
        render.begin()
        blur.visit()
        render.endToLua()
        ret = render.getSprite()
    } else {
        ret = cc.DrawNode.create()
        var radius = Math.max(width, height) / 2
        ret.drawSolidCircle(cc.p(0, 0), radius, 0, Math.max(20, Math.min(Math.ceil(radius / 4), 35)), width / radius / 2, height / radius / 2, cc.c4f(0, 0, 0, 1))
    }
    ret.setAnchorPoint(cc.p(0.5, 0.5))
    ret.removeFromParent(true)
    ret.setPosition(cc.p(x + width / 2, y + height / 2))
    if (type(config.startScale) === "number" && config.startScale !== 0) {
        ret.startScale = config.startScale
        ret.setScale(ret.startScale)
    } else {
        var vSize = cc.Director.getInstance().getVisibleSize()
        var distance = Math.max(Math.max(x, y), Math.max(vSize.width - x - width, vSize.height - y - height))
        var targetWidth = distance * 2 + width
        ret.startScale = targetWidth / width * 1.414
        ret.setScale(ret.startScale)
    }
    ret.scaleTime = config.scaleTime || 0.3
    return ret
}
GameGuideMask.maskTouchSquare = function (config, touch, event, paras) {
    var [x, y, width, height] = GameGuidePosition.getPosition(config.posMode, (paras || table()).instance, config.p1, config.p2, config.width, config.height, config.posRatio, config.posAdd, config.sizeRatio)
    var rect = cc.rect(x, y, width, height)
    // WARN: maybe multi result
    return cc.rectContainsPoint(rect, touch.getLocation())
}
GameGuideMask.maskTouchOval = function (config, touch, event, paras) {
    var [x, y, width, height] = GameGuidePosition.getPosition(config.posMode, (paras || table()).instance, config.p1, config.p2, config.width, config.height, config.posRatio, config.posAdd, config.sizeRatio)
    return 1 >= Math.pow((touch.getLocation().x - (x + width / 2)), 2) / (width * width / 4) + Math.pow((touch.getLocation().y - (y + height / 2)), 2) / (height * height / 4)
}
module.exports = GameGuideMask
